import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function AdminTickets() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/tickets").then((r) => setItems(r.data)); }, []);

  const badge = (s) => {
    const map = {
      open: "bg-amber-500/20 text-amber-400 border-amber-500/30",
      answered: "bg-blue-500/20 text-blue-400 border-blue-500/30",
      closed: "bg-zinc-500/20 text-zinc-400 border-zinc-500/30",
    };
    return <Badge className={`rounded-sm border ${map[s]}`}>{s}</Badge>;
  };

  return (
    <div className="space-y-6" data-testid="admin-tickets-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2">// admin · tickets</div>
        <h1 className="font-heading text-3xl font-bold tracking-tighter">Tickets de suporte</h1>
      </div>
      <div className="border border-white/10 bg-[#121214]">
        <ul className="divide-y divide-white/10">
          {items.map((t) => (
            <li key={t.ticket_id} className="p-5 hover:bg-white/5">
              <Link to={`/dashboard/tickets/${t.ticket_id}`} className="flex items-center justify-between" data-testid={`admin-ticket-row-${t.ticket_id}`}>
                <div>
                  <div className="font-medium">{t.subject}</div>
                  <div className="text-xs text-zinc-500 font-mono mt-1">{t.department} · prio {t.priority} · {t.messages?.length || 0} mensagens · {fmtDate(t.updated_at)}</div>
                </div>
                {badge(t.status)}
              </Link>
            </li>
          ))}
          {items.length === 0 && <li className="p-10 text-center text-zinc-500">Sem tickets.</li>}
        </ul>
      </div>
    </div>
  );
}
